<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "EmailBase"
}
</script>

<style scoped>

</style>
